import { FiltersRepository } from '@/infrastructure/session-storage'
import { useSearchParams } from 'react-router'

const filterRepository = new FiltersRepository()

const updateDependencies = {
  saveURLSessionFilters:
    filterRepository.saveURLSessionFilters.bind(filterRepository)
}

export function useFilter(filterName: string) {
  const [searchParams, setSearchParams] = useSearchParams()
  const paramOptions = searchParams.getAll(filterName)

  function getFilterValues() {
    return paramOptions
  }

  function updateFilterValues(
    values: string[],
    { saveURLSessionFilters }: typeof updateDependencies
  ) {
    const newParams = new URLSearchParams(searchParams)
    newParams.delete(filterName)
    values.forEach((value) => newParams.append(filterName, value))
    setSearchParams(newParams, { replace: true })
    saveURLSessionFilters(newParams.toString())
  }

  return {
    getFilterValues,
    updateFilterValues: (values: string[]) =>
      updateFilterValues(values, updateDependencies)
  }
}
